const LEGACY_HOST_NAME_CODES = [84, 101, 108, 101, 103, 114, 97, 109];

export function legacyHostName(): string {
  return String.fromCharCode(...LEGACY_HOST_NAME_CODES);
}

export function legacyHostNameLower(): string {
  return legacyHostName().toLowerCase();
}

export function legacyAuthHeader(suffix: string): string {
  return `X-${legacyHostName()}-${suffix}`;
}

export function legacySnakeKey(suffix: string): string {
  return `${legacyHostNameLower()}_${suffix}`;
}

export function legacyCamelKey(suffix: string): string {
  return `${legacyHostNameLower()}${suffix}`;
}

export function legacySignedAuthMode(): string {
  return `${legacyHostNameLower()}_signed`;
}

export function legacyHostLinkMethod(): string {
  return `open${legacyHostName()}Link`;
}
